module.exports = __webpack_public_path__ + "assets/img/6.57c5e70b.png";